exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deleteFriendConfirm {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.deleteFriendConfirm .iconStyle {\n  font-size: 38px;\n}\n.deleteFriendConfirm b {\n  top: auto;\n}\n.pageHeaderBox .firstRowBox .actionPostBox .el-loading-spinner {\n  margin-top: -10px;\n}\n.pageHeaderBox .firstRowBox .actionPostBox .el-loading-spinner .circular {\n  width: 20px;\n  height: 20px;\n}\n", ""]);

// exports
